import request from 'api/requestUtils'

export interface LinkPersonalAccountRequest {
  country_code: string
  email: string
  givenName: string
  id_google: string
  signup_domain: string
  token_id: string
  surname: string
}

export async function requestPostGoogleLinkPersonalAccount(data: LinkPersonalAccountRequest) {
  return request.post<App.ApiResponse<any>, LinkPersonalAccountRequest>(
    '/api/business-traveller/employees/social-link-personal-account',
    data,
    { credentials: 'include' },
  )
}
